import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import Modal from '../../../../../../components/Modal';
import TextInput from '../../../../../../components/TextInput';
import { formatPrice } from '@/utils/formatter';
import {
  createProduct as createProductMutation,
  updateProduct as updateProductMutation,
} from '../../../../../../graphql/mutations';
import { Sheet } from '../AllergenModal/styled';
import { Field } from '../ProductEditModal/styled';
import Button from '../../../../../../components/Button';
import VatSelector from '../../../../../../components/VatSelector';
import i18n from '@/utils/i18n';

function VariantCreateModal({ product, brandId, onClose, vatRates }) {
  const [values, setValues] = useState({
    name: i18n.t('Menu:variantName').toLowerCase(),
    price: 100000,
    title: `🐇 ${i18n.t('Menu: placeholder')}`,
    vat_rate: 70,
  });
  const [createProduct, { loading: updatingCreateProduct }] = useMutation(
    createProductMutation,
  );
  const [updateProduct, { loading: updatingProduct }] = useMutation(
    updateProductMutation,
  );

  function handleChange({ target }) {
    const { name, value } = target;
    const type = target.getAttribute('type');
    const stateName = target.getAttribute('data-state-name') || name;
    const formattedValue = type === 'number' ? +value : value;
    setValues({ ...values, [stateName]: formattedValue });
  }

  async function handleCreate() {
    await createProduct({
      variables: {
        payload: {
          ...values,
          brand_id: brandId,
          type: 'VARIANT',
        },
      },
      update: (cache, { data: { createProduct: createdVariant } }) => {
        // eslint-disable-next-line no-console
        console.log('createdVariant', createdVariant);
        let defaultVariantId = createdVariant.id;
        let variantIds = [];
        if (Array.isArray(product.variants) && product.variants.length > 0) {
          defaultVariantId = product.variants.find(
            (v) => v.is_default,
          ).variant_id;
          variantIds = product.variants.map((v) => v.variant_id);
        }
        variantIds.push(createdVariant.id);

        updateProduct({
          variables: {
            id: product.id,
            product: {
              variants: {
                default_variant: defaultVariantId,
                variant_ids: variantIds,
              },
            },
          },
          update: () => onClose(),
        });
      },
    });
  }

  return (
    <Modal onClose={onClose}>
      <Sheet>
        <Field>
          <TextInput
            name="variant-title"
            data-state-name="name"
            value={values.name}
            onChange={handleChange}
            placeholder={i18n.t('Menu:variantName')}
          />
        </Field>
        <Field>
          <TextInput
            name="price"
            value={values.price}
            onChange={handleChange}
            placeholder={`${i18n.t('Menu:variantPrice')}: ${formatPrice(
              values.price,
            )}`}
            type="number"
          />
        </Field>
        <Field>
          <TextInput
            placeholder={i18n.t('Common:title')}
            name="variant-title"
            data-state-name="title"
            value={values.title || ''}
            onChange={handleChange}
          />
        </Field>

        <VatSelector
          onChange={handleChange}
          vatRate={values.vat_rate}
          vatRates={vatRates}
        />

        <Button
          loading={updatingCreateProduct || updatingProduct}
          onClick={handleCreate}
        >
          {i18n.t('Menu:addNewVariant')}
        </Button>
      </Sheet>
    </Modal>
  );
}

VariantCreateModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  brandId: PropTypes.string.isRequired,
  vatRates: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default VariantCreateModal;
